import { useEffect, useState } from 'react'

const IncompleteProfileBanner = ({
  name = 'onboarding',
  auth,
  onCompleteClick,
}) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!auth?.user) return

    const key = `skip_${name}`
    const expireKey = `skip_${name}_expire`

    const skipped = localStorage.getItem(key)
    const expire = localStorage.getItem(expireKey)

    // If no skip or already complete → don't show
    if (!skipped || auth.user.onboarding_complete === 1) {
      setVisible(false)
      return
    }

    // Check expiry
    if (expire) {
      const now = new Date()
      const expireDate = new Date(expire)

      if (now > expireDate) {
        localStorage.removeItem(key)
        localStorage.removeItem(expireKey)
        setVisible(false)
        return
      }
    }

    setVisible(true)
  }, [auth, name])

  if (!visible) return null

  return (
    <div className="w-full bg-[#fff7ed] border border-[#fed7aa] text-[#9a3412] px-4 py-3 rounded-lg flex items-center justify-between mb-4">
      <div className="text-sm">
        Your profile isn’t complete yet. Some features may be limited.
      </div>

      <button
        onClick={onCompleteClick}
        className="ml-4 px-4 py-2 bg-[#ea580c] text-white text-sm rounded-md hover:bg-[#c2410c] transition"
      >
        Complete Profile
      </button>
    </div>
  )
}

export default IncompleteProfileBanner